import * as React from 'react'

import * as style from './match-checkboxes-group.module.scss'

type Props = {
  matchAllChecked: boolean
  matchNameTeacherChecked: boolean
  matchNameGradeChecked: boolean
  onChangeAllMatchCheckbox: (event: React.ChangeEvent<HTMLInputElement>) => void
  onChangeNameTeacherCheckbox: (event: React.ChangeEvent<HTMLInputElement>) => void
  onChangeNameGradeCheckbox: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export default function MatchCheckBoxesGroup(props: Props): React.ReactElement {
  const {
    matchAllChecked,
    matchNameTeacherChecked,
    matchNameGradeChecked,
    onChangeAllMatchCheckbox,
    onChangeNameTeacherCheckbox,
    onChangeNameGradeCheckbox
  } = props

  return (
    <div className={style.matchCheckBoxGroup}>
      <input
        type="checkbox"
        id="match-all"
        checked={matchAllChecked}
        onChange={event => onChangeAllMatchCheckbox(event)}
      />
      <label htmlFor="match-all" className={style.allMatchedStudent}>
        {' '}
        Matches name, teacher and grade
      </label>
      <input
        type="checkbox"
        id="match-name-teacher"
        checked={matchNameTeacherChecked}
        onChange={event => onChangeNameTeacherCheckbox(event)}
      />
      <label htmlFor="match-name-teacher" className={style.nameTeacherMatchedStudent}>
        {' '}
        Matches name and teacher
      </label>
      <input
        type="checkbox"
        id="match-name-grade"
        checked={matchNameGradeChecked}
        onChange={event => onChangeNameGradeCheckbox(event)}
      />
      <label htmlFor="match-name-grade"> Matches name and grade</label>
    </div>
  )
}
